import { jwtDecode } from 'jwt-decode';
import type { AuthUser, UserRole } from '@/types/auth.types';

interface DecodedTokenPayload {
  sub?: string;
  id?: string;
  email?: string;
  name?: string;
  display_name?: string;
  role?: string;
  department_id?: string;
  client_context?: string[];
  is_active?: boolean;
  [key: string]: any;
}

const NORMALIZE_ROLE_MAP: Record<string, UserRole> = {
  admin: 'admin',
  'platform admin': 'admin',
  'tenant admin': 'admin',
  manager: 'manager',
  doc_specialist: 'document_specialist',
  document_specialist: 'document_specialist',
  'document specialist': 'document_specialist',
  qc_operator: 'qc_operator',
  'qc operator': 'qc_operator',
  proofreader: 'proofreader',
  intake_coordinator: 'intake_coordinator',
  'intake coordinator': 'intake_coordinator',
};

export function decodeJWT(token: string): AuthUser {
  try {
    const decoded = jwtDecode<DecodedTokenPayload>(token);
    const candidateRole = decoded.role || (Array.isArray(decoded.roles) ? decoded.roles[0] : 'intake_coordinator');
    const rawRole = String(candidateRole || 'intake_coordinator').toLowerCase().trim();
    const role: UserRole = NORMALIZE_ROLE_MAP[rawRole] || 'intake_coordinator';

    return {
      id: decoded.id || decoded.sub || '',
      email: decoded.email || '',
      name: decoded.display_name || decoded.name || (decoded.email ? decoded.email.split('@')[0] : 'User'),
      role,
      department_id: decoded.department_id,
      client_context: decoded.client_context,
      is_active: decoded.is_active !== undefined ? decoded.is_active : true,
    };
  } catch (error) {
    console.error('Failed to decode JWT token:', error);
    return {
      id: '',
      email: '',
      name: 'User',
      role: 'intake_coordinator',
      is_active: true,
    };
  }
}
